import { render, staticRenderFns } from "./TicketByUser.vue?vue&type=template&id=835327ba"
import script from "./TicketByUser.vue?vue&type=script&lang=js"
export * from "./TicketByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports